module.exports = __webpack_public_path__ + "static/media/bg-logo--full-anniversary-white.e449bb21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/bg-logo--full-anniversary-white.svg
// module id = 64
// module chunks = 6